import React, { useState, useEffect, useRef } from "react";
import axiosInstance from "../../../../axios";
import { Loading } from "../../../Other/Loading";
import Button from "../../../Other/element/Button";

const QuizTest = ({ courseId, isPurchased }) => {
  const [quizStart, setQuizStart] = useState(false);
  const [quizQuestion, setQuizQuestion] = useState({
    quizId: null,
    length: "",
    name: "",
  });
  const [load, setLoad] = useState(false);
  const [show, setShow] = useState(true);
  const [quizResult, setQuizResult] = useState(false);
  const [values, setValues] = useState([]);
  const [another, setAnother] = useState(true);
  const [final, setFinal] = useState(false);
  const [nextQuiz, setNextQuiz] = useState();
  const [nextResponse, setNextResponse] = useState(false);
  const [handleSubmit, setHandleSubmit] = useState(true);
  const [submitResponse, setSubmitResponse] = useState(null);
  const [submitID, setSubmitID] = useState({
    testId: null,
    questionId: "",
    answerIds: [],
  });
  const [quizFetch, setQuizFetch] = useState();
  const [currents, setcurrents] = useState(1);

  const [result, setResult] = useState({
    RightAnswer: "",
    WrongAnswer: "",
    show: false,
  });
  const [currentQuestion, setCurrentQuestion] = useState(0);

  useEffect(() => {
    axiosInstance
      .get(`/quiz/${courseId}`)
      .then((res) => {
        setQuizQuestion({
          ...quizQuestion,
          quizId: res?.data?.data[0]?.id,
          length: res.data.data[0]?.questions,
          name: res.data.data[0]?.name,
          guidelines: res.data.data[0]?.guidelines,
        });
      })
      .catch((res) => console.log(res));
  }, [courseId]);

  const handle = () => {
    setLoad(true);
    axiosInstance
      .post("/quiz/start/test", quizQuestion)
      .then((res) => {
        setShow(false);
        setQuizFetch(res.data.data);
      })
      .catch((res) => console.log(res));
  };

  const submitHanlder = () => {
    setLoad(false);
    axiosInstance
      .post("/quiz/answer/submit", submitID)
      .then((res) => {
        if (res?.data?.message === "Test results") {
          setResult({
            ...result,
            RightAnswer: res?.data?.data?.rightAns,
            WrongAnswer: res?.data?.data?.wrongAns,
            show: false,
          });
          setSubmitResponse(res.data.data);
          setFinal(true);
          setNextResponse(true);
          setQuizResult(true);
          setLoad(true);
          setHandleSubmit(false);

          setSubmitID({ testId: null, questionId: "", answerIds: [] });
        } else {
          setSubmitResponse(res.data.data);
          setNextResponse(true);
          setHandleSubmit(false);
          setLoad(true);
          setSubmitID({ testId: null, questionId: "", answerIds: [] });
        }
      })
      .catch((res) => console.log(res));
  };

  const answerHandler = (option, id, type) => {
    let checkedClonedValues = values;
    checkedClonedValues.push(id);
    setValues(checkedClonedValues);
    let clonedValues;
    switch (type) {
      case 1:
        clonedValues = [];
        clonedValues.push(id);
        break;
      case 2:
        clonedValues = [];
        clonedValues.push(id);
        break;

      case 3:
        clonedValues = submitID.answerIds;
        clonedValues.push(id);
        break;

      default:
        break;
    }

    setSubmitID({
      ...submitID,
      answerIds: clonedValues,
      questionId: option.questionId,
      testId: quizFetch?.id,
    });
  };

  const resultHandler = () => {
    setResult({
      ...result,
      show: true,
    });
    setQuizResult(!quizResult);
    setSubmitResponse(null);
    setNextResponse(false);
    setAnother(false);
  };

  const nextHandler = () => {
    setSubmitID({ testId: null, questionId: "", answerIds: [] });
    setValues([]);
    setNextResponse(false);
    setAnother(!another);
    setcurrents(currents + 1);
    setHandleSubmit(true);
    setNextQuiz(submitResponse);
    setResult({ ...result, show: false });
  };

  const nextHandlerSecond = () => {
    if (values?.length > 0) {
      values.map((items) => {
        document.getElementById(items).checked = false;
      });
    }
    setValues([]);
    setSubmitID({ testId: null, questionId: "", answerIds: [] });
    setNextQuiz(submitResponse);
    setHandleSubmit(true);
    setNextResponse(false);
    setcurrents(currents + 1);
  };

  const endHandler = () => {
    setNextResponse(false);
    setAnother(!another);
    setcurrents(1);
    setFinal(false);
    setShow(true);
    setLoad(false);
    setHandleSubmit(true);
    setQuizStart(false);
  };

  const calculation = (right, wrong) => {
    const values = (right / (right + wrong)) * 100;
    const result = values.toFixed(1);
    return result;
  };

  return (
    <>
      {quizQuestion?.quizId !== undefined && (
        <div className="accordion-content quiz-content-1 custom-new-padding-accordin">
          {show && (
            <div className="course-description">
              <p
                className="quiz-content custom-quiz-section"
                onClick={() => setQuizStart(!quizStart)}
              >
                {quizStart ? "-" : "+"} Aptitutde Test for {quizQuestion.name}
              </p>

              {quizStart && (
                <>
                  <p className="quiz-content">Quiz Specific Instructions:</p>
                  <p className="quiz-content">
                    {quizQuestion?.guidelines} &nbsp;
                    {quizQuestion?.length?.length} Questions in this test, you
                    will need to answer all. Good Luck!
                  </p>

                  {load && <Loading />}

                  {!load && isPurchased && (
                    <div className="innerQuiz-button">
                      {" "}
                      <Button
                        className="btn-3 create-question"
                        handleClick={handle}
                        title={"Start Quiz"}
                      />
                    </div>
                  )}
                </>
              )}
            </div>
          )}
          {another && (
            <>
              {!show && (
                <div className="course-description">
                  <div className="inline-questions">
                    <p className="quiz-start-btn" style={{ marginTop: "0px" }}>
                      {currents <= quizQuestion?.length?.length && currents}/
                      {quizQuestion?.length?.length}
                    </p>
                    {/* <p className="multiple-choice-p">
                      {quizFetch &&
                      quizFetch?.questions[currentQuestion]?.type === 3
                        ? "Multiple Select Questions(more than 1 correct answer)"
                        : quizFetch?.questions[currentQuestion].type === 1
                        ? "Multiple Choice Questions"
                        : quizFetch?.questions[currentQuestion].type === 2 &&
                          "Fill in the Gaps/Blanks"}
                    </p> */}
                  </div>

                  <p className="quiz-content">
                    {quizFetch &&
                      quizFetch?.questions[currentQuestion].question}
                  </p>

                  {quizFetch &&
                    quizFetch?.questions[currentQuestion]?.options.map(
                      (option, id) => (
                        <div className="multiplechoice-section">
                          <ul>
                            <li
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "start",
                                margin: "0px",
                                marginTop: "5px",
                              }}
                            >
                              <input
                                type="radio"
                                style={{
                                  textAlign: "center",
                                  width: "25px",
                                }}
                                name={
                                  quizFetch.questions[currentQuestion].type ===
                                  3
                                    ? option.id
                                    : "name"
                                }
                                id={option.id}
                                onClick={() =>
                                  answerHandler(
                                    option,
                                    option.id,
                                    quizFetch.questions[currentQuestion].type
                                  )
                                }
                              />
                              <label>{option.answer}</label>
                            </li>
                          </ul>
                        </div>
                      )
                    )}

                  {/* {nextResponse && (
                    <div className="quiz-Result quiz-start-btn">
                      {submitResponse?.currentAnswerIsRight === 0 ? (
                        "Incorrect"
                      ) : (
                        <div className="result-section">
                          <p>Correct</p>
                          <div className="success-icon"></div>

                          {nextResponse && (
                            <div>
                              <button
                                className="quiz-submit-btn quiz-nextStep"
                                onClick={nextHandler}
                              >
                                NEXT
                              </button>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  )} */}

                  {nextResponse && (
                    <div>
                      <div className="multiplechoice-section"></div>
                      <div className="custom-box">
                        {submitResponse?.currentAnswerIsRight === true ? (
                          <>
                            <div className="custom-box-answer">
                              <p className="success-icon"></p>
                            </div>
                            <p style={{ color: "green" }}>Correct</p>
                            {submitResponse?.rightAnswer.map((answer) => (
                              <p>Right Answer :{answer.answer}</p>
                            ))}
                          </>
                        ) : (
                          <>
                            <div className="custom-box-answer">
                              <span>X</span>
                            </div>
                            <p style={{ color: "red" }}>Incorrect</p>
                            {submitResponse?.rightAnswer?.map((answer) => (
                              <p>Right Answer :{answer.answer}</p>
                            ))}
                          </>
                        )}
                      </div>
                      {!quizResult && (
                        <>
                          {nextResponse && (
                            <button
                              className="quiz-submit-btn"
                              onClick={nextHandler}
                            >
                              Next
                            </button>
                          )}
                        </>
                      )}

                      {quizResult && (
                        <button
                          className="quiz-submit-btn quizResult"
                          onClick={resultHandler}
                        >
                          Result
                        </button>
                      )}
                    </div>
                  )}
                  {!load && <Loading />}
                  {submitID.testId !== null && (
                    <>
                      {handleSubmit && (
                        <>
                          {!nextResponse && (
                            <>
                              {load && (
                                <button
                                  className="quiz-submit-btn "
                                  onClick={submitHanlder}
                                >
                                  Submit
                                </button>
                              )}
                            </>
                          )}
                        </>
                      )}
                    </>
                  )}
                </div>
              )}
            </>
          )}

          {result.show === false && (
            <>
              {nextQuiz && (
                <div className="course-description">
                  <div className="inline-questions">
                    <p className="quiz-start-btn" style={{ marginTop: "0px" }}>
                      {currents <= quizQuestion?.length?.length && currents}/
                      {quizQuestion?.length?.length}
                    </p>
                    <p className="multiple-choice-p">
                      {nextQuiz && nextQuiz.nextQuestion.type === 3
                        ? "Multiple Select Questions(more than 1 correct answer)"
                        : nextQuiz.nextQuestion.type === 1
                        ? "Multiple Choice Questions"
                        : nextQuiz.nextQuestion.type === 2 &&
                          "Fill in the Gaps/Blanks"}
                    </p>
                  </div>
                  <p className="quiz-content">
                    {nextQuiz && nextQuiz.nextQuestion.question}
                  </p>

                  {nextQuiz?.nextQuestion.options.map((option, id) => (
                    <div className="multiplechoice-section">
                      <ul>
                        <li
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "start",
                            margin: "0px",
                            marginTop: "5px",
                          }}
                        >
                          <input
                            type="radio"
                            className="quiz-inputbox "
                            style={{
                              textAlign: "center",
                              width: "25px",
                            }}
                            name={
                              nextQuiz?.nextQuestion?.type === 3
                                ? option?.id
                                : "name"
                            }
                            id={option.id}
                            onClick={() =>
                              answerHandler(
                                option,
                                option.id,
                                nextQuiz?.nextQuestion?.type
                              )
                            }
                          />

                          <label>{option.answer}</label>
                        </li>
                      </ul>
                    </div>
                  ))}

                  {nextResponse && (
                    <div>
                      <div className="multiplechoice-section"></div>
                      <div className="custom-box">
                        {submitResponse?.currentAnswerIsRight === false ? (
                          <>
                            <div className="custom-box-answer">
                              <span>X</span>
                            </div>
                            <p style={{ color: "red" }}>Incorrect</p>
                            {submitResponse?.rightAnswer.map((answer) => (
                              <p>Right Answer : {answer.answer}</p>
                            ))}
                          </>
                        ) : (
                          <>
                            <div className="custom-box-answer">
                              <p className="success-icon"></p>
                            </div>
                            <p style={{ color: "green" }}>Correct</p>
                            {submitResponse?.rightAnswer.map((answer) => (
                              <p>Right Answer :{answer.answer}</p>
                            ))}
                          </>
                        )}
                      </div>
                      {!quizResult && (
                        <>
                          {nextResponse && (
                            <button
                              className="quiz-submit-btn"
                              onClick={nextHandlerSecond}
                            >
                              Next
                            </button>
                          )}
                        </>
                      )}
                      {quizResult && (
                        <button
                          className="quiz-submit-btn quizResult"
                          onClick={resultHandler}
                        >
                          Result
                        </button>
                      )}
                    </div>
                  )}

                  {!load && <Loading />}
                  {submitID.testId !== null && (
                    <>
                      {handleSubmit && (
                        <button
                          className="quiz-submit-btn"
                          onClick={submitHanlder}
                        >
                          Submit
                        </button>
                      )}
                    </>
                  )}
                </div>
              )}
            </>
          )}

          {result.show && (
            <>
              {final && (
                <div className="course-description">
                  <p
                    className="quiz-content"
                    style={{ fontSize: "25px", fontWeight: "500" }}
                  >
                    Quiz Result
                  </p>
                  <div className="flex-0">
                    <div>
                      <p className="quiz-content">
                        Correct :{result.RightAnswer}
                      </p>

                      <p className="quiz-content">
                        Incorrect :{result.WrongAnswer}
                      </p>
                    </div>
                    <div className="">
                      <svg viewBox="0 0 36 36" class="circular-chart">
                        <path
                          class="circle-bg"
                          d="M18 2.0845
      a 15.9155 15.9155 0 0 1 0 31.831
      a 15.9155 15.9155 0 0 1 0 -31.831"
                        />
                        <path
                          class="circle"
                          stroke={
                            calculation(
                              result.RightAnswer,
                              result.WrongAnswer
                            ) < 80
                              ? "#f30000"
                              : "#20cd20"
                          }
                          stroke-dasharray={`${calculation(
                            result.RightAnswer,
                            result.WrongAnswer
                          )}, 100`}
                          d="M18 2.0845
      a 15.9155 15.9155 0 0 1 0 31.831
      a 15.9155 15.9155 0 0 1 0 -31.831"
                        />

                        <text x="13 " y="13.35" class="percentage">
                          {calculation(result.RightAnswer, result.WrongAnswer)}%
                        </text>

                        {calculation(result.RightAnswer, result.WrongAnswer) <
                          80 && (
                          <text
                            x="15"
                            y="22.35"
                            class="passing_marks"
                            style={{
                              fontSize: "10px",
                              stroke: "red",
                              fontWeight: "100",
                            }}
                          >
                            X
                          </text>
                        )}
                        {calculation(result.RightAnswer, result.WrongAnswer) >
                          80 && (
                          <text
                            x="14"
                            y="22.35"
                            class="passing_marks text-checkbox-0"
                          >
                            &#x2714;
                          </text>
                        )}

                        <text x="10" y="27.35" class="passing_marks">
                          Passing 80 %
                        </text>
                      </svg>
                    </div>
                  </div>

                  <button className="quiz-submit-btn" onClick={endHandler}>
                    Take Again
                  </button>
                  <div>
                    {/* <input
                      type="checkbox"
                      style={{ width: "25px", marginTop: "25px" }}
                    />
                    <label>
                      I acknowledge that i have compeleted this section
                    </label> */}
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      )}
    </>
  );
};
export default QuizTest;
